export const MINUTES_PER_DAY = 24 * 60

export const TIMING_MODES = {
  ALL_DAY: 'allDay',
  TIME_SLOT: 'timeSlot'
}

export const ALL_DAY_PERIOD = ['00:00', '00:00']

export const DEFAULT_FIRST_START_TIME = '09:00'
export const DEFAULT_FIRST_END_TIME = '17:00'
export const DEFAULT_SECOND_START_TIME = '18:00'
export const DEFAULT_SECOND_END_TIME = '22:00'

export const MIN_TIME = '00:00'
export const MAX_TIME = '23:30'
